import React from 'react';
import { Reveal } from '../Reveal';
const teachingTasks = ['Organizing explanations', 'Preparing demonstrations', 'Finding visual examples', 'Creating meaningful practice', 'Anticipating mistakes', 'Assessing student progress'];

/** "You know brows." — the bridge between the preview and the pain. */
export function IntroSection() {
  return <section aria-labelledby="intro-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-113" data-mp="3l6l2ztunmimx">
      <Reveal className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-20" data-id="element-114" data-mp="mofv98urkf71">
        <div className="text-center lg:text-left" data-id="element-115" data-mp="csm8kwnbz5bj">
          <h2 id="intro-heading" className="font-display text-[2.6rem] font-bold leading-[1.02] text-brand-charcoal sm:text-[3.4rem]" data-id="element-116" data-mp="crb4swtvxxkf">
            You know brows.
          </h2>
          <p className="mt-4 font-display text-[1.6rem] font-semibold italic leading-snug text-brand-gold sm:text-[1.9rem]" data-id="element-117" data-mp="2xkel8fvfhoji">
            But teaching them takes time.
          </p>
          <p className="mx-auto mt-6 max-w-lg text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px] lg:mx-0" data-id="element-118" data-mp="uio4p7xed95l">
            <strong className="font-semibold text-brand-charcoal" data-id="element-119" data-mp="zfy51imbr587">Brow Instructor Ready™</strong> brings
            those pieces together into one structured professional education system designed to support
            the way Brow Educators actually teach.
          </p>
        </div>

        <div data-id="element-120" data-mp="bpkanlg9ouag">
          <p className="mb-4 text-center font-body text-[13px] text-brand-charcoal/55 lg:text-left" data-id="element-121" data-mp="bpu2zfosbdjb">
            Teaching also means…
          </p>
          <ul className="grid gap-px overflow-hidden rounded-[20px] border border-brand-charcoal/8 bg-brand-charcoal/8 sm:grid-cols-2" role="list" data-id="element-122" data-mp="1th8wgpbuxo1">
            {teachingTasks.map(task => <li key={task} className="bg-white px-6 py-5 font-display text-[1.25rem] font-semibold leading-snug text-brand-charcoal" data-id="element-123" data-mp="3oxx1modzoks3">
                {task}
              </li>)}
          </ul>
        </div>
      </Reveal>
    </section>;
}